<template>
  <div class="fieldset mt-4" v-if="subMenu && subMenuData">
    <legend class="md-whiteframe-z2" align="center">
      {{ subMenu["@attributes"].txtid | translate }}
    </legend>
    <v-layout wrap>
      <v-flex class="px-2" md4 xs4 v-if="subMenu.field.length">
        <p class="temp-heading text-no-wrap">
          {{ "lng_weather_ref_title" | translate }}
        </p>
        <v-layout
          row
          wrap
          align-center
          v-for="(fields, index) in subMenu.field"
          :key="fields['@attributes'].txtid + index"
        >
          <v-flex xs12 class="temp-info" v-if="index >= 1 && index <= 7">
            <p class="mb-0">{{ index }}</p>
            <v-btn
              @click="openHelpDialog(fields['@attributes'].helptxtid)"
              flat
              icon
              class="ma-0 help-ico ml-1"
            >
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fit
                height="100%"
                width="100%"
                preserveAspectRatio="xMidYMid meet"
                focusable="false"
              >
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path
                  d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
                ></path>
              </svg>
            </v-btn>
            <v-text-field
              class="pt-0 mt-0 mx-2"
              :readonly="
                readOnly ? true : checkFieldAccess(fields['@attributes'])
              "
              :disabled="
                readOnly ? true : checkFieldAccess(fields['@attributes'])
              "
              :value="
                parseFloat(subMenuData[fields['@attributes'].udp].val).toFixed(
                  1
                ) | tempConversion
              "
              @click.native="
                readOnly ? null : chooseDialog(fields['@attributes'])
              "
              @keydown="readOnly ? null : chooseDialog(fields['@attributes'])"
            ></v-text-field>
            <p class="mb-0">{{ fields["@attributes"].unittxt | translate }}</p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="px-2" md4 xs4 v-if="subMenu.field.length">
        <p class="temp-heading text-no-wrap">
          {{ "lng_weather_flowtemp_title" | translate }}
        </p>
        <v-layout
          row
          wrap
          align-center
          v-for="(fields, index) in subMenu.field"
          :key="fields['@attributes'].txtid + index"
        >
          <v-flex xs12 class="temp-info" v-if="index >= 8 && index <= 14">
            <v-btn
              @click="openHelpDialog(fields['@attributes'].helptxtid)"
              flat
              icon
              class="ma-0 help-ico ml-1"
            >
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fit
                height="100%"
                width="100%"
                preserveAspectRatio="xMidYMid meet"
                focusable="false"
              >
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path
                  d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
                ></path>
              </svg>
            </v-btn>
            <v-text-field
              class="pt-0 mt-0 mx-2"
              :readonly="
                readOnly ? true : checkFieldAccess(fields['@attributes'])
              "
              :disabled="
                readOnly ? true : checkFieldAccess(fields['@attributes'])
              "
              :value="
                parseFloat(subMenuData[fields['@attributes'].udp].val).toFixed(
                  1
                ) | tempConversion
              "
              @click.native="
                readOnly ? null : chooseDialog(fields['@attributes'])
              "
              @keydown="readOnly ? null : chooseDialog(fields['@attributes'])"
            ></v-text-field>
            <p class="mb-0">{{ fields["@attributes"].unittxt | translate }}</p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="px-2" md4 xs4 v-if="subMenu.field.length">
        <p class="temp-heading text-no-wrap">
          {{ "lng_weather_power_title" | translate }}
        </p>
        <v-layout
          row
          wrap
          align-center
          v-for="(fields, index) in subMenu.field"
          :key="fields['@attributes'].txtid + index"
        >
          <v-flex xs12 class="temp-info" v-if="index >= 15 && index <= 21">
            <v-btn
              @click="openHelpDialog(fields['@attributes'].helptxtid)"
              flat
              icon
              class="ma-0 help-ico ml-1"
            >
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fit
                height="100%"
                width="100%"
                preserveAspectRatio="xMidYMid meet"
                focusable="false"
              >
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path
                  d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
                ></path>
              </svg>
            </v-btn>
            <v-text-field
              class="pt-0 mt-0 mx-2"
              :readonly="
                readOnly ? true : checkFieldAccess(fields['@attributes'])
              "
              :disabled="
                readOnly ? true : checkFieldAccess(fields['@attributes'])
              "
              :value="
                parseFloat(subMenuData[fields['@attributes'].udp].val).toFixed(
                  1
                ) | tempConversion
              "
              @click.native="
                readOnly ? null : chooseDialog(fields['@attributes'])
              "
              @keydown="readOnly ? null : chooseDialog(fields['@attributes'])"
            ></v-text-field>
            <p class="mb-0">{{ fields["@attributes"].unittxt | translate }}</p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex class="px-0" md12 xs12 v-if="subMenu.field.length">
        <div
          style="width:200;height:300px"
          class="wrap-chart flex charts-align weatherChart"
        ></div>
      </v-flex>
    </v-layout>
    <help-dialog
      :help-text="selectedHelpText"
      :openDialog="helpDialog"
      :closeDialog="closeHelpDialog"
    ></help-dialog>
    <tech-access-dialog
      :openDialog="techDialog"
      :closeDialog="closeTechDialog"
      :giveAccess="giveTechAccess"
    ></tech-access-dialog>
    <slider-range-dialog
      :field-text="selectedFieldText"
      :field-udp="selectedFieldUdp"
      :field-desc="selectedFieldDesc"
      :value-obj="selectedField"
      :selected-language="getLanguage"
      :dialog="closeSliderDialog"
      :openDialog="dialog"
      :on-response="showResponseAlert"
      :key-component="keyComponent"
    ></slider-range-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HelpDialog from "./HelpDialog";
import TechAccessDialog from "./TechAccessDialog";
import SliderRangeDialog from "./SliderRangeDialog";
import { translate } from "../common/HelperFunctions";

export default {
  name: "WeatherFieldItems",
  data() {
    return {
      dialog: false,
      selectedField: undefined,
      selectedFieldUdp: undefined,
      selectedFieldText: "",
      selectedFieldDesc: "",
      selectField: {},
      selectfieldData: [],
      selectedSelectField: {},
      helpDialog: false,
      selectedHelpText: "",
      techDialog: false,
      chartDataToPlot: [],
      keyComponent: 0
    };
  },
  components: {
    HelpDialog,
    TechAccessDialog,
    SliderRangeDialog
  },
  props: {
    subMenu: {
      type: Object,
      default: () => {}
    },
    subMenuData: {
      type: Object,
      default: () => {}
    },
    responseAlert: {
      type: Function,
      default: undefined
    }
  },
  // watch: {
  //   subMenuData: function(newVal) {
  //     if (
  //       this.fields["@attributes"].type === "countdowntimer" &&
  //       newVal.val > 0
  //     ) {
  //       this.countdownTimer(newVal.val);
  //     }
  //   }
  // },
  created() {},
  mounted() {
    if (this.subMenu.field.length) {
      this.getChartDataToPlot();
      this.plotChart();
    }
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getTechAccess"]),
    readOnly() {
      return this.getUser.credentials === "readonly";
    },
    getLanguage() {
      return localStorage.getItem("language");
    }
  },
  methods: {
    checkField() {
      return (
        this.fields["@attributes"].udp === "notify.email" ||
        this.fields["@attributes"].udp === "notify.phone"
      );
    },
    openHelpDialog(helpText) {
      this.selectedHelpText = translate(helpText);
      this.helpDialog = true;
    },
    // close Help text showing dialog
    closeHelpDialog() {
      this.helpDialog = false;
    },
    // open technical access dialog
    openTechDialog() {
      this.techDialog = true;
    },
    // close technical access dialog
    closeTechDialog() {
      this.techDialog = false;
    },
    // save technical access given
    giveTechAccess() {
      this.$store.commit("global/setTechAccess", true);
      this.techDialog = false;
    },
    // function to check field's auth
    checkFieldAccess(field) {
      return field.auth === "smith" || field.auth === "nbe"
        ? !this.getTechAccess
        : false;
    },
    // function to show dialog either technical access or update field's range slider
    chooseDialog(field) {
      this.checkFieldAccess(field)
        ? this.openTechDialog()
        : this.openRangeSliderDialog(this.subMenuData, field);
    },
    closeSliderDialog(val) {
      this.dialog = val;
    },
    showResponseAlert(text) {
      // prop function to show response alert
      this.responseAlert(text);
    },
    openRangeSliderDialog(identifierValueObj, fieldInfo) {
      this.selectedFieldUdp = fieldInfo.udp;
      let valueObj = identifierValueObj[fieldInfo.udp];
      valueObj.val = parseFloat(valueObj.val).toFixed(1);
      this.selectedField = valueObj;
      this.selectedFieldText = fieldInfo.txtid;
      this.selectedFieldDesc = fieldInfo.helptxtid;
      this.keyComponent += 1;
      this.dialog = true;
    },
    plotChart() {
      $.plot(
        $(this.$el.getElementsByClassName("weatherChart")),
        this.chartDataToPlot,
        this.setChartOptions()
      );
    },
    getChartDataToPlot() {
      let menuData = this.subMenuData;
      let data1 = [];
      let data2 = [];
      let data3 = [];
      this.subMenu.field.forEach((element, index) => {
        if (index >= 1 && index <= 7) {
          data1.push([
            menuData[element["@attributes"].udp].val,
            menuData[element["@attributes"].udp].val
          ]);
        }
        if (index >= 8 && index <= 14) {
          data2.push([
            menuData[this.subMenu.field[index - 7]["@attributes"].udp].val,
            menuData[element["@attributes"].udp].val
          ]);
        }
        if (index >= 15 && index <= 21) {
          data3.push([
            menuData[this.subMenu.field[index - 14]["@attributes"].udp].val,
            menuData[element["@attributes"].udp].val
          ]);
        }
      });
      this.chartDataToPlot = [
        {
          color: "#FF0000",
          data: data1,
          label: translate("lng_weather_ref_title")
        },
        {
          color: "#0000FF",
          data: data2,
          label: translate("lng_weather_flowtemp_title")
        },
        {
          color: "#FF00FF",
          data: data3,
          label: translate("lng_weather_power_title")
        }
      ];
    },
    setChartOptions() {
      return {
        points: {
          radius: 3,
          show: true,
          fill: true
        },
        lines: { show: true },
        legend: {
          show: true,
          labelBoxBorderColor: "#000",
          noColumns: 0,
          position: "sw"
        },
        grid: {
          hoverable: true,
          borderWidth: 2,
          backgroundColor: {
            colors: ["#999", "#ffffff"]
          }
        },
        // transform: function (v) { console.log('kkkkk: ', v); },
        tooltip: true,
        tooltipOpts: {
          defaultTheme: false,
          content: (label, x, y) => {
            let tooltip = `<div class="tooltip-content graph-bg"><h4>${
              label ? label : ""
            }</h4><ul><li>${y}</li></ul></div>`;
            return tooltip;
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.temp-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}
.temp-info p {
  margin: 4px 0;
  line-height: 28px;
}
@media (max-width: 768px) {
  .temp-heading.text-no-wrap {
    white-space: normal !important;
    font-size: 12px;
    min-height: 35px;
  }
  .fieldset {
    padding: 20px 10px;
  }
  .v-text-field {
    margin: 0 !important;
  }
  .temp-info > p:first-child {
    position: relative;
    left: -7px;
  }
  .v-text-field {
    font-size: 12px;
  }
  .boiler-page .v-btn--icon {
    width: 22px;
  }
  .v-text-field input {
    padding-bottom: 0;
  }
}
</style>
